import parse from "html-react-parser";
import s from "./ProductPickerBadges.module.scss";

const ProductPickerBadges = ({ bannerBg, badgeText, badgeBg, badgeTextColor, rowText, enableLink, onUpgrade }) => {
  const isClickable = enableLink && !!onUpgrade;

  return (
    <div
      className={`${s["picker-badges"]} ${!badgeText ? s["picker-badges--no-badge"] : ""} ${isClickable ? s["picker-badges--clickable"] : ""}`}
      style={{ backgroundColor: bannerBg }}
      onClick={
        isClickable
          ? (e) => {
              e.stopPropagation();
              onUpgrade();
            }
          : undefined
      }
    >
      {badgeText && (
        <span className={s["picker-badges__badge"]} style={{ backgroundColor: badgeBg, color: badgeTextColor }}>
          {badgeText}
        </span>
      )}
      <span className={s["picker-badges__text"]}>{parse(rowText || "")}</span>
    </div>
  );
};

export default ProductPickerBadges;
